import { useQuery } from '@tanstack/react-query';
import { apiCall } from '../../lib/api.js';
import { useAccessToken, requireToken } from '../../lib/use-access-token.js';

export interface ConnectionListItem {
  provider: string;
  name: string;
  status: 'unconfigured' | 'connected' | 'failing';
  lastTestedAt: string | null;
  lastTestError: string | null;
  lastRotatedAt: string | null;
  configuredAt: string | null;
  isDefault: boolean;
}

export function useConnections(companyId: string | undefined) {
  const { token } = useAccessToken();
  return useQuery<{ items: ConnectionListItem[] }, Error>({
    queryKey: ['integrations', companyId, token],
    enabled: !!companyId && !!token,
    queryFn: async ({ signal }) =>
      apiCall(`/v1/companies/${companyId}/integrations`, { token: requireToken(token), signal }),
    staleTime: 30_000,
    retry: false,
  });
}
